import { useMutation } from '@tanstack/react-query';
import { createSupplyRequest } from '@entities/requestMaterial/api/api-funcs';

export const useCreateSupplyRequestQuery = () =>
    useMutation({
        mutationFn: createSupplyRequest,
        onSuccess: () => {
            window.location.reload();
        },
    });
